import React from 'react'
import { useDispatch } from 'react-redux'
import mainLogo from '../../images/Arup-logo.png'
import styled from '@emotion/styled'
import { reset } from '../../actions'

const logoStyle = {
  maxWidth: 70,
  marginRight: 10,
}

const Container = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export default function Logo() {
  const dispatch = useDispatch()

  const click = async () => {
    dispatch(reset())
  }

  return (
    <Container onClick={click}>
      <img src={mainLogo} alt="logo" style={logoStyle} />
    </Container>
  )
}
